import React from 'react';
import { Formik, Form } from 'formik'
import CustomTextField from './CustomTextField'
import CustomButton from './CustomButton'

export default function ChangePasswordForm({ onSubmit, onSuccess, onFailure }) {

  return <Formik
    initialValues={{
      new_password: '',
      confirm_password: '',
    }}
    validate={(values) => {
      const errors = {}

      if (values.new_password.length < 8) {
        errors.new_password = 'Le mot de passe doit contenir au minimum 8 caractères'
      }
      if (values.new_password !== values.confirm_password) {
        errors.confirm_password = 'Les mots de passe saisis ne sont pas identiques'
      }

      return errors
    }}
    onSubmit={(values, { setSubmitting }) => {
      setSubmitting(true)
      onSubmit(values)
        .then((res) => res.json())
        .then((data) => {
          setSubmitting(false);
          onSuccess(data);
        })
        .catch((error) => {
          setSubmitting(false);
          onFailure(error);
        });
    }}
  >
    {({ submitForm, isSubmitting }) => (
      <Form>
        <CustomTextField
          name="new_password"
          placeholder="Nouveau mot de passe"
          type="password"
          required
        />
        <CustomTextField
          name="confirm_password"
          placeholder="Confirmation du mot de passe"
          type="password"
          required
          style={{ marginBottom: 16 }}
        /> 
          <CustomButton
          color="secondary"
          onClick={submitForm}
          disabled={isSubmitting}
        >
          CONFIRMER
        </CustomButton>
      </Form>
    )}
  </Formik>;
}
